import React from 'react'
import PropTypes from 'prop-types'

import { format } from 'date-fns'
import StatusIndicator from './StatusIndicator'
import { Typography } from '@material-ui/core'
import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'

const DateCreated = ({ record }) => {
  const date = new Date(record.CreatedDate)
  const shouldRenderStatus = record.Trigger !== ONE_TIME_TRIGGER
  const getStatus = () => {
    if (record.Disabled) {
      return 'Disabled'
    }
    return record.IsDraft ? 'Draft' : 'Live'
  }
  return (
    <div>
      <Typography gutterBottom={shouldRenderStatus}>{format(date, 'PP')}</Typography>
      {shouldRenderStatus && (
        <StatusIndicator
          disabled={record.Disabled}
          status={getStatus()}
        />
      )}
    </div>
  )
}

DateCreated.propTypes = {
  record: PropTypes.object.isRequired,
}

export default DateCreated
